import { Box, HighlightContainer, Spacer, Typography } from '@qbe/ads-core';
import React from 'react';

import { useAppContent } from '~/hooks';
import { OccupationsListItem } from '~/types/refData';

import { ContextualHelpWithButton } from '../../components-ds/ContextualHelp/ContextualHelpWithButton';

export const OccupationDescription = ({
  occupationItem,
  heading,
}: {
  occupationItem: OccupationsListItem;
  heading?: string;
}) => {
  const { getJSXContent } = useAppContent({
    basePath: 'dsme.occupationDescriptionComponent.contextualhelpers',
  });

  return (
    <>
      <Box>
        <HighlightContainer>
          <Typography textAlign="center" fontWeight="fontWeightBold" gutterBottom>
            {heading ?? occupationItem.desc}
            <Box component="span" sx={{ marginLeft: '4px', display: 'inline-block' }}>
              <ContextualHelpWithButton>
                <Typography>{getJSXContent('description.description')}</Typography>
              </ContextualHelpWithButton>
            </Box>
          </Typography>
          <Typography>{occupationItem?.anzsicShortDescription}</Typography>
        </HighlightContainer>
      </Box>
      <Spacer size="lg" />
    </>
  );
};
